<app-modal-wrapper [title]="'common.label.confirm' | translate" (closeAction)="close()">
  <div modalBody>
    <span *ngIf="confirmDelete">{{ 'common.message.confirm_delete' | translate: { subject: subject, name: name } }}</span>
    <span *ngIf="!confirmDelete">{{subject}}</span>
  </div>
  <ng-container modalFooter>
    <button class="btn btn-primary mr-2" (click)="accept()">{{ 'common.button.accept' | translate}}</button>
    <button class="btn btn-secondary" ngbAutofocus (click)="close()">{{ 'common.button.cancel' | translate}}</button>
  </ng-container>
</app-modal-wrapper>
